export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_05.144b7f54.png";